import { render } from "./StudentToOrgMatching.vue?vue&type=template&id=123f81fe"
import script from "./StudentToOrgMatching.vue?vue&type=script&lang=js"
export * from "./StudentToOrgMatching.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__